import { FC } from "react";
import { Button, Modal, Typography } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "../../../components/Forms/components/ButtonMenu.js";
import { Acquisition } from "@/types";
import AcquisitionsAPI from "@/api/acquisitions";
import { useSnackbar, VariantType } from "notistack";
import { usePermissions } from "@/hooks/usePermissions";
import LoggingAPI from "@/api/logging";

interface DeleteAcquisitionModalProps {
  show: boolean;
  onClose: () => void;
  onDelete: () => void;
  defaultData: Acquisition;
}

export const DeleteAcquisitionModal: FC<DeleteAcquisitionModalProps> = ({
  show,
  onClose,
  onDelete,
  defaultData,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = usePermissions();

  const handleDelete = async () => {
    try {
      if (defaultData?.acq_id) {
        await AcquisitionsAPI.deleteAcquisitions({
          acq_id: defaultData.acq_id,
        });
        onDelete?.();
        enqueueSnackbar(`Acquisition ${defaultData?.acq_name || ""} deleted`, {
          variant: "success" as VariantType,
        });
        LoggingAPI.createLog({
          user_id: currentUser.user_id,
          message: `Deleted Acquisition: ${defaultData?.acq_name}`,
          event: "acquisition:delete",
          object_type: "acquisition",
        });
      }
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        `An error occurred while deleting acquisition ${
          defaultData?.acq_name || ""
        }. Please try again.`,
        { variant: "error" as VariantType }
      );
    }
  };

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Title>Delete Acquisition</Modal.Title>
      <div style={{ fontWeight: 500, margin: "20px 0px" }}>
        Are you sure you want to delete acquisition{" "}
        <span style={{ fontWeight: 800 }}>"{defaultData?.acq_name}"</span>?
        <p>This action cannot be undone.</p>
      </div>
      <ButtonMenu>
        <Button variant="subtle" size="xs" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          size="xs"
          onClick={handleDelete}
        >
          Delete
        </Button>
      </ButtonMenu>
    </Modal>
  );
};
